/**
 * Утилита для логирования
 *
 * В продакшене логирует только ошибки
 * В разработке логирует все сообщения
 */

type LogLevel = 'log' | 'warn' | 'error' | 'debug';

const isDevelopment = (): boolean => import.meta.env.DEV;

/**
 * Логирует сообщение только в режиме разработки
 */
const devLog = (level: LogLevel, ...args: unknown[]): void => {
  if (isDevelopment()) {
    // eslint-disable-next-line no-console
    console[level](...args);
  }
};

/**
 * Логирует сообщение всегда (для критических ошибок)
 */
const alwaysLog = (level: LogLevel, ...args: unknown[]): void => {
  // eslint-disable-next-line no-console
  console[level](...args);
};

export const logger = {
  /**
   * Логирует информационное сообщение (только в dev)
   */
  log: (...args: unknown[]): void => {
    devLog('log', ...args);
  },

  /**
   * Логирует предупреждение (только в dev)
   */
  warn: (...args: unknown[]): void => {
    devLog('warn', ...args);
  },

  /**
   * Логирует ошибку (всегда)
   */
  error: (...args: unknown[]): void => {
    alwaysLog('error', ...args);
  },

  /**
   * Логирует отладочное сообщение (только в dev)
   */
  debug: (...args: unknown[]): void => {
    devLog('debug', ...args);
  },
};

